module.exports = __webpack_public_path__ + "Purple-3cc271ff.webp";